import { render, staticRenderFns } from "./CurrencyForm2.vue?vue&type=template&id=6333d358"
import script from "./CurrencyForm2.vue?vue&type=script&lang=js"
export * from "./CurrencyForm2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports